export default __webpack_public_path__ + "static/media/Linkedin-white.7b7fc014.svg";